import React from 'react'
import { Carousel, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import en7p from "../../assets/images/products/en-7p/img4.webp";
import io400 from "../../assets/images/products/io-400/img3.webp";
import smS230 from "../../assets/images/products/sm-S230/img5.webp";
import XBlue from "../../assets/images/products/x-blue/img2.webp";
import io60u from "../../assets/images/products/io-600u/io600u.png";
import sm2f97 from "../../assets/images/products/sm-2f97/sm-2f97.png";


function HomeOurProducts() {
    return (
        <section className="performace_of_electrod__wrapper silder__wrapper">
            <Container>
                <Row>
                    <Col>
                        <div className="title__wrap center_aligned regular">
                            <h2>Our Products</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Carousel indicators={false} pause={false}>
                            <Carousel.Item interval={4000}>
                                <Row className="justify-content-center">
                                    <Col xs={9} md={11}>
                                        <Row className="align-items-center">
                                            <Col md={4} className="offset-md-0">
                                                <div className="en7p__image align-item-center">
                                                    <picture>
                                                        <source srcSet={en7p} type="image/webp" />
                                                        <img
                                                            src={en7p}
                                                            height={300}
                                                            className="thumb__image w-100 h-100"
                                                            alt="Electrodes"
                                                        />
                                                    </picture>
                                                </div>
                                            </Col>
                                            <Col md={6} className="offset-md-1">
                                                <div className="title__wrap">
                                                    <h2>
                                                        EN-7P – Alkaline<span> Water Machine </span>
                                                    </h2>
                                                </div>
                                                <ul id="image" className="first">
                                                    <li>7 Platinum-Titanium Plates</li>
                                                    <li>Automatic Draining System</li>
                                                    <li>250W SMPS Power Control System</li>
                                                </ul>
                                                <Link
                                                    to="/products/ionia-en-7p-alkaline-water-machine"
                                                    className="readmore__btn"
                                                >
                                                    Read More
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                            <Carousel.Item interval={4000}>
                                <Row className="justify-content-center">
                                    <Col xs={9} md={11}>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <div className="io400u_image align-item-center">
                                                    <picture>
                                                        <source srcSet={io400} type="image/webp" />
                                                        <img
                                                            src={io400}
                                                            height={300}
                                                            className="thumb__image w-100 h-100"
                                                            alt="Electrodes"
                                                        />
                                                    </picture>
                                                </div>
                                            </Col>
                                            <Col md={6} className="offset-md-1">
                                                <div className="title__wrap">
                                                    <h2>
                                                        IO-400U – Alkaline{" "}
                                                        <span>Water Machine</span>
                                                    </h2>
                                                </div>
                                                <ul id="image" className="first">
                                                    <li>
                                                        DARC System – Automatic change of flow path (6
                                                        Overseas Patents)
                                                    </li>
                                                    <li>
                                                        Alarm message and ionization disabled during hot
                                                        water inflow.
                                                    </li>
                                                    <li>
                                                        Exact calculation of filter durability with Flux
                                                        control.
                                                    </li>
                                                    <li>Extended range of pH selection and control.</li>
                                                    <li>Modern Design.</li>
                                                </ul>
                                                <Link
                                                    to="/products/ionia-iq-400u-alkaline-water-machine"
                                                    className="readmore__btn"
                                                >
                                                    Read More
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                            <Carousel.Item interval={4000}>
                                <Row className="justify-content-center">
                                    <Col xs={9} md={11}>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <div className="sms230_image align-item-center">
                                                    <picture>
                                                        <source srcSet={smS230} type="image/webp" />
                                                        <img
                                                            src={smS230}
                                                            height={300}
                                                            className="thumb__image w-100 h-100"
                                                            alt="Electrodes"
                                                        />
                                                    </picture>
                                                </div>
                                            </Col>
                                            <Col md={6} className="offset-md-1">
                                                <div className="title__wrap">
                                                    <h2>
                                                        SM-S230TL – Alkaline
                                                        <span>Water Machine</span>
                                                    </h2>
                                                </div>
                                                <ul id="image" className="first">
                                                    <li>12(5P+7P) Platinum-Titanium Plates</li>
                                                    <li>Premium Dual Filtration</li>
                                                    <li>350W SMPS Power Control System</li>
                                                    <li>RFID Genuine filter chip</li>
                                                    <li>Super Strong Acidic (pH2.5~pH12)</li>
                                                </ul>
                                                <Link
                                                    to="/products/ionia-sm-s230tl-alkaline-water-machine"
                                                    className="readmore__btn"
                                                >
                                                    Read More
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                            <Carousel.Item interval={4000}>
                                <Row className="justify-content-center">
                                    <Col xs={9} md={11}>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <div className="xblue_image align-item-center">
                                                    <picture>
                                                        <source srcSet={XBlue} type="image/webp" />
                                                        <img
                                                            src={XBlue}
                                                            height={300}
                                                            className="thumb__image w-100 h-100"
                                                            alt="Electrodes"
                                                        />
                                                    </picture>
                                                </div>
                                            </Col>
                                            <Col md={6} className="offset-md-1">
                                                <div className="title__wrap">
                                                    <h2>
                                                        X-BLUE – Alkaline <span>Water Machine</span>
                                                    </h2>
                                                </div>
                                                <ul id="image" className="first">
                                                    <li>5 Platinum (Planized Titanium)</li>
                                                    <li>Luxury exterior design</li>
                                                    <li>
                                                        Automatic reversed cleaning system causes platinum
                                                        coated with titanium electrode to have at least 20
                                                        years longevity
                                                    </li>
                                                    <li>
                                                        Color LCD display easily identifies 3 different
                                                        functions
                                                    </li>
                                                </ul>
                                                <Link
                                                    to="/products/ionia-x-blue-alkaline-water-machine"
                                                    className="readmore__btn"
                                                >
                                                    Read More
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                            <Carousel.Item interval={4000}>
                                <Row className="justify-content-center">
                                    <Col xs={9} md={11}>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <div className="xblue_image align-item-center">
                                                    <picture>
                                                        <source srcSet={io60u} type="image/webp" />
                                                        <img
                                                            src={io60u}
                                                            height={300}
                                                            className="thumb__image w-100 h-100"
                                                            alt="Electrodes"
                                                        />
                                                    </picture>
                                                </div>
                                            </Col>
                                            <Col md={6} className="offset-md-1">
                                                <div className="title__wrap">
                                                    <h2>
                                                        IO-600U FAUCET  <span>UNDER SINK</span>
                                                    </h2>
                                                </div>
                                                <ul id="image" className="first">
                                                    <li>DARC System - Automatic change of flow path (6 Overseas Patents)</li>
                                                    <li>2.8” LCD Touch Panel Display</li>
                                                    <li>Exact calculation of filter durability with Flux control.</li>
                                                    <li>Extended range of pH selection and control. Solenoid
                                                        Type + 9P water cell</li>
                                                </ul>
                                                {/* <Link
                                                    to="/products/ionia-x-blue-alkaline-water-machine"
                                                    className="readmore__btn"
                                                >
                                                    Read More
                                                </Link> */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                            <Carousel.Item interval={4000}>
                                <Row className="justify-content-center">
                                    <Col xs={9} md={11}>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <div className="xblue_image align-item-center">
                                                    <picture>
                                                        <source srcSet={sm2f97} type="image/webp" />
                                                        <img
                                                            src={sm2f97}
                                                            height={300}
                                                            className="thumb__image w-100 h-100"
                                                            alt="Electrodes"
                                                        />
                                                    </picture>
                                                </div>
                                            </Col>
                                            <Col md={6} className="offset-md-1">
                                                <div className="title__wrap">
                                                    <h2>
                                                        SM-2F97” TFT  <span>LCD LUXURY</span>
                                                    </h2>
                                                </div>
                                                <ul id="image" className="first">
                                                    <li>DARC System - Automatic change of flow path (6 Overseas Patents)</li>
                                                    <li>7inch TFT Display 800*480Pixels with LCD backlight and Touch Panel</li>
                                                    <li>350W Level SMPS Power Control System RFID Genuine filter chip</li>
                                                </ul>
                                                {/* <Link
                                                    to="/products/ionia-x-blue-alkaline-water-machine"
                                                    className="readmore__btn"
                                                >
                                                    Read More
                                                </Link> */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Carousel.Item>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default HomeOurProducts